<template>
    <v-container fluid>
        <page-header title="Cups" icon="mdi-trophy">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createCup">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="cups"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
        >
            <template v-slot:row-actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click="$router.push(`/cups/${item.id}/bracket`)">
                            <v-icon small>mdi-tournament</v-icon>
                        </v-btn>
                    </template>
                    <span>Δέντρο κυπέλλου</span>
                </v-tooltip>
            </template>
        </array-view>
    </v-container>
</template>

<script>
    import cupService from '@/services/cup'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Cup',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                cups: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Title',
                        value: 'title'
                    },
                    {
                        text: 'Start Date',
                        value: 'startDate'
                    },
                    {
                        text: 'End Date',
                        value: 'endDate'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    }
                ],
                tableKey: 'cups',
                filterFields: [
                    { key: 'title', label: 'Title', type: 'text' },
                    { key: 'active', label: 'Active', type: 'boolean' },
                    { key: 'startDate', label: 'Start Date', type: 'dateRange' },
                    { key: 'endDate', label: 'End Date', type: 'dateRange' }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/cups/${item.id}/${action}`)
            },
            onDelete(item, page) {
                cupService.deleteCup(item.id).then(() => {
                    this.page = page
                    this.fetchItems()
                })
            },
            createCup() {
                this.$router.push(`/cups/create`)
            },
            fetchItems() {
                cupService.getFilteredCups(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.cups = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
